import { useForm, ValidationError } from "@formspree/react";

function ContactForm() {
	const [state, handleSubmit] = useForm("meqwbadk");
	if (state.succeeded) {
		return (
			<div>
				<ContactForm />
				<p className="text-green-500">تم ارسال الرسالة بنجاح</p>
			</div>
		);
	}

	return (
		<div>
			<h2 className="text-3xl my-3">ألديكم استفسار؟</h2>
			<form className="text-black text-start font-cairo font-bold" onSubmit={handleSubmit}>
				<div className="my-2">
					<label htmlFor=" name"></label>
					<input className="rounded-md w-32 pr-3" placeholder="الاسم" type="text" id="name" name="Name" required />
					<ValidationError prefix="Name" field="Name" errors={state.errors} />
				</div>
				<div className="my-2">
					<label htmlFor="email"></label>
					<input className="rounded-md pr-3" placeholder="ألبريد الالكتروني" type="email" id="email" name="Email" required />
				</div>
				<ValidationError prefix="Email" field="Email" errors={state.errors} />
				<div className="my-2">
					<label htmlFor="message"></label>
					<textarea className="rounded-md pr-3" placeholder="الاستفسار..." id="message" name="Message" rows="5" required></textarea>
					<ValidationError prefix="Message" field="Message" errors={state.errors} />
				</div>

				<button className="text-white px-5 py-1 rounded-md bg-brown" type="submit" disabled={state.submitting}>
					أرسل
				</button>
			</form>
		</div>
	);
}

export default ContactForm;
